// 检查所有li中的a链接地址是否有#，如有则它作为二级标题
window.addEventListener("DOMContentLoaded", function () {
  const linkLists = document.querySelectorAll('.site-footer .grid__item .site-footer__linklist li');
    linkLists.forEach(link => {
      // 检查 href 属性是否为 #
      const a = link.querySelector('a')
      if (a.getAttribute('href') === '#') {
        console.log("link",link)
        // 设置特殊样式
        link.classList.add("second-title")
        a.style.fontWeight='520'
        a.style.color='rgba(255, 255, 255, 0.85)'
        a.style.pointerEvents = 'none'
      }
    });
})